var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    name: "year",
                    type: "year",
                    default: "today",
                    label: "LBL0003648",
                  },
                  model: {
                    value: _vm.searchParam.year,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "year", $$v)
                    },
                    expression: "searchParam.year",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-equip", {
                  attrs: {
                    label: "LBLEQUIP",
                    type: "search",
                    name: "equipmentCd",
                  },
                  model: {
                    value: _vm.searchParam.equipmentCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "equipmentCd", $$v)
                    },
                    expression: "searchParam.equipmentCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    codeGroupCd: "MIM_CHECK_RESULT_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "resultCd",
                    label: "LBL0003785",
                  },
                  model: {
                    value: _vm.searchParam.resultCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "resultCd", $$v)
                    },
                    expression: "searchParam.resultCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    name: "period",
                    label: "LBL0003786",
                    defaultStart: "-6M",
                    defaultEnd: "6M",
                  },
                  model: {
                    value: _vm.period,
                    callback: function ($$v) {
                      _vm.period = $$v
                    },
                    expression: "period",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2" },
              [
                _c("c-select", {
                  attrs: {
                    editable: _vm.editable,
                    comboItems: _vm.typeItems,
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "equipmentType",
                    label: "LBL0003787",
                  },
                  model: {
                    value: _vm.searchParam.equipmentType,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "equipmentType", $$v)
                    },
                    expression: "searchParam.equipmentType",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-multi-select", {
                  attrs: {
                    editable: _vm.editable,
                    codeGroupCd: "REGULATION_BILL_API_CD",
                    itemText: "codeName",
                    itemValue: "code",
                    label: "관련법규",
                    name: "relatedLawList",
                    maxValues: "3",
                  },
                  model: {
                    value: _vm.searchParam.relatedLawList,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "relatedLawList", $$v)
                    },
                    expression: "searchParam.relatedLawList",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "LBL0003788",
            tableId: "equipmentCd",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            merge: _vm.grid.merge,
          },
          on: { linkClick: _vm.linkClick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "resultName"
                    ? [
                        props.row["resultName"] === "부적합"
                          ? _c("div", { staticClass: "description-td" }, [
                              _vm._v(
                                " " + _vm._s(props.row["resultName"]) + " "
                              ),
                            ])
                          : _c("div", [
                              _vm._v(
                                " " + _vm._s(props.row["resultName"]) + " "
                              ),
                            ]),
                      ]
                    : _vm._e(),
                  col.name === "statusTypeCd"
                    ? [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-size-chip",
                            attrs: {
                              color: _vm.setTagColor(props.row.statusTypeCd),
                              outline: "",
                              square: "",
                              clickable: true,
                              "text-color": "white",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.linkClick(props.row, {
                                  name: "statusTypeCd",
                                })
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.setTagName(props.row.statusTypeCd)) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c("template", { slot: "table-button" }, [
            _c(
              "div",
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _c("c-btn", {
                      attrs: { label: "LBLSEARCH", icon: "search" },
                      on: { btnClicked: _vm.getList },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }